<template>
  <tk-container class="repair" :status="status">
    <tkui-header center slot="header">
      <tk-icon @click.native="back" slot="left-menu">Return</tk-icon>
      一键报修
    </tkui-header>
    <div class="body">
      <textarea v-model="content" class="form" cols="30" rows="10" placeholder="请填写水机问题描述"></textarea>
      <tkui-button @click.native="up" class="block raised primary rounded">提交</tkui-button>
    </div>
  </tk-container>
</template>

<script>
  export default {
    data () {
      return {
        status: false,
        content: ''
      }
    },
    computed: {
      machine () {
        return this.$store.state.machine || {}
      },
      user () {
        return this.$store.state.user || {}
      }
    },
    methods: {
      async up () {
        let bool = /^\s+$/g.test(this.content)
        if (!this.content || bool) {
          this.$tkGlobal.toast.add('请填写报修内容')
          return
        }
        try {
          this.status = 'waiting'
          await this.$tkParse.post('/classes/report', {
            'content': this.content,
            'machine': this.machine.objectId
          })
          if (this.user.repairService) {
            await this.$tkParse.post('/sms/send', {
              'phone': this.user.repairService,
              'templateId': 'GgHE6',
              'vars': {
                'user': this.user.username || '',
                'message': this.content,
                'name': this.machine.name || '暂无',
                'address': this.machine.address || '暂无'
              }
            })
          }
          this.content = ''
          this.status = false
          this.$tkGlobal.toast.add('报修成功')
        } catch (e) {
          this.status = false
          this.$tkGlobal.toast.add('报修失败')
        }
      },
      back () {
        this.$back()
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .repair{
    background: #ffffff;
    .body{
      padding: 25px 15px 0 15px;
      .form{
        width: 100%;
        height: 150px;
        border: 1px solid #CCCCCC;
        box-sizing: border-box;
        resize:none;
        margin-bottom: 75px;
        padding: 10px;
        color: #999999;
        font-size: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/app/detail/repair.vue